import {FirestoreBaseModel} from "./FirestoreBaseModel";

export class Chats implements FirestoreBaseModel {
    // {
    //         // userIds: number[], // 参加ユーザーのID array
    //         // unreadMessagesXxx: string[], // 読んでないメッセージ(Xxxは未読をもつユーザーID) doc の array
    // }
    data : any;
}
